import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AlertCircle, Check, KeyRound } from 'lucide-react';
import { api } from '../services/api';

function ChangePasswordSection() {
  const { t } = useTranslation('settings');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [saving, setSaving] = useState(false);
  const [changed, setChanged] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setChanged(false);
    setSaving(true);
    try {
      await api.changePassword(currentPassword, newPassword);
      setCurrentPassword('');
      setNewPassword('');
      setChanged(true);
    } catch (err) {
      const detail = err.response?.data?.detail;
      if (detail === 'wrong_password') setError(t('password.errors.wrongPassword'));
      else if (err.response?.status === 429) setError(t('password.errors.tooManyAttempts'));
      else if (err.response?.status === 422 && Array.isArray(detail)) setError(detail.map((d) => d.msg).join('. '));
      else setError(t('password.errors.generic'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="settings-section" data-testid="change-password-section">
      <div className="section-header">
        <KeyRound size={20} />
        <h2>{t('password.title')}</h2>
      </div>
      <form className="section-content" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="current-password">{t('password.current')}</label>
          <input
            id="current-password"
            type="password"
            autoComplete="current-password"
            className="input"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="new-password">{t('password.new')}</label>
          <input
            id="new-password"
            type="password"
            autoComplete="new-password"
            className="input"
            placeholder={t('password.newPlaceholder')}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            minLength={8}
            maxLength={128}
          />
        </div>
        {error && (
          <p className="form-hint password-error" data-testid="change-password-error">
            <AlertCircle size={14} /> {error}
          </p>
        )}
        <button type="submit" className="btn btn-primary" disabled={saving || !currentPassword || !newPassword}>
          {saving ? <div className="spinner" /> : changed ? <Check size={16} /> : <KeyRound size={16} />}
          {changed ? t('password.changed') : t('password.submit')}
        </button>
      </form>
    </section>
  );
}

export default ChangePasswordSection;
